
<template>
  <div>
    <!-- <ul class="side-nav" v-if="RoleId == 179">
      <li class="side-nav-title">Assignment</li>
      <li class="side-nav-item">
        <router-link to="/trainer-assignment/list" class="side-nav-link">
          <v-icon icon size="25px" color="#B0BEC5"> mdi-account-file </v-icon>
          <span>Trainer Assignment List</span>
        </router-link>
      </li>
    </ul> -->

    <ul class="side-nav">
      <li class="side-nav-title">Program</li>
      <li class="side-nav-item" @click="closeMenuDialog">
        <router-link to="/program/list" class="side-nav-link">
          <v-icon icon size="25px" color="#B0BEC5">
            mdi-calendar-multiple
          </v-icon>
          <span>Program List</span>
        </router-link>
      </li>

      <li class="side-nav-title" @click="closeMenuDialog" v-if="AdminFlag">
        Faculty
      </li>
      <li class="side-nav-item" @click="closeMenuDialog" v-if="AdminFlag">
        <router-link to="/faculty/list" class="side-nav-link">
          <v-icon icon size="25px" color="#B0BEC5"> mdi-account-plus </v-icon>
          <span>Faculty List</span>
        </router-link>
      </li>
      <li class="side-nav-title" @click="closeMenuDialog" v-if="AdminFlag">
        Trainers
      </li>
      <li class="side-nav-item" @click="closeMenuDialog" v-if="AdminFlag">
        <router-link to="/trainer/list" class="side-nav-link">
          <v-icon icon size="25px" color="#B0BEC5">
            mdi mdi-account-group
          </v-icon>
          <span>Trainers List</span>
        </router-link>
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    dialog: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      AdminFlag: false,
      RoleId: 0,
    };
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");

      var admin_flag = this.$session.get("AdminFlag");
      admin_flag = admin_flag == (null || undefined) ? 0 : admin_flag;
      console.log({ admin_flag });
      this.AdminFlag = admin_flag;

      var role_id = this.$session.get("RoleId");
      role_id = role_id == (null || undefined) ? 0 : role_id;
      console.log({ role_id });
      this.RoleId = role_id;
    },
    closeMenuDialog() {
      console.log("closeMenuDialog called");
      this.$emit("hideMenuDialog", false);
    },
  },
  beforeMount() {
    console.log("beforeMount called");
    this.refreshPageData();
  },
};
</script>